module.exports = __webpack_public_path__ + "img/c2672f369c1e498cac8e5c9397dfc667.996dafe3.png";